// Infinite loading na stronie bloga (co 6 postów w gridzie)
jQuery(function($) {
    var $grid = $('.js-blog-grid');
    var $trigger = $('.js-blog-load-more-trigger');
    var $loader = $('.js-blog-grid-loader');

    if (!$grid.length || !$trigger.length) {
        return;
    }

    var page = 1; // pierwsza porcja (offset 1) już wyrenderowana w PHP
    var loading = false;
    var hasMore = true;
    var threshold = 200; // ile px przed triggerem zaczynamy ładować

    function loadMorePosts() {
        if (loading || !hasMore) return;
        loading = true;
        if ($loader.length) {
            $loader.show();
        }

        $.ajax({
            url: ajax.url,
            type: 'POST',
            dataType: 'json',
            data: {
                action: 'bwell_load_more_blog_posts',
                page: page,
            }
        }).done(function(response) {
            if (response && response.success && response.data && response.data.html) {
                $grid.append(response.data.html);
                page++;
                hasMore = !!response.data.hasMore;
            } else {
                hasMore = false;
            }
        }).always(function() {
            loading = false;
            if ($loader.length) {
                $loader.hide();
            }
        });
    }

    $(window).on('scroll.blogInfinite', function() {
        if (!hasMore || loading) return;

        var triggerOffset = $trigger.offset().top;
        var scrollBottom = $(window).scrollTop() + $(window).height();

        if (scrollBottom + threshold >= triggerOffset) {
            loadMorePosts();
        }
    });
});
